import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CoreService } from 'src/app/core/services/core.service';
import { StorageService } from 'src/app/core/storage/storage.service';
import { OrderRequest } from 'src/app/shared/model/order.model';
import { User } from 'src/app/shared/model/user.model';
import { CommonModule } from '@angular/common';
import { I18NextModule } from 'angular-i18next';
import { StepperComponent } from 'src/app/shared/components/stepper/stepper.component';
import { RequestType } from 'src/app/shared/model/requestType.enum';
import { ModalConfirmRequestComponent } from 'src/app/shared/components/modal-confirm-request/modal-confirm-request.component';
import i18next from 'i18next';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { EsService } from 'src/app/core/services/es.service';

@Component({
  standalone: true,
  selector: 'app-e-s',
  templateUrl: './e-s.component.html',
  styleUrls: ['./e-s.component.scss'],
  imports: [CommonModule, I18NextModule, RouterModule, StepperComponent]
})
export class ESComponent implements OnInit, AfterViewInit {
  user!: User;
  requestType = '';
  requestTypeEnum = RequestType;
  modalContent?: NgbModalRef;
  spinner = false;
  extraEmail = '';
  extraPhone = '';
  carConfigurator = true;
  requestObj!: OrderRequest;
  moreThanOneVehicle = false;
  landing2 = false;
  loading = false;

  steps = new Map<string, boolean>();
  approvers = false;
  constructor(
    private storageService: StorageService,
    public coreService: CoreService,
    public esService: EsService,
    public router: Router,
    public modalConfig: NgbModal,
    public dialog: MatDialog,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    this.landing2 = this.storageService.get('landing2') || false;
    this.storageService.set('navigation', 'newRequest');
    this.user = this.storageService.get('config');
    this.requestType = this.requestTypeEnum.es;
    this.setSteps();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigationService.handleNavigationView('newRequest');
    }, 0);
  }

  setSteps() {
    this.steps.set('vehicle-finder', true);
    this.steps.set('request-info', true);
    this.steps.set('additionalInfo', true);
  }

  openConfirmationModal(newRequestData: any) {
    const dialogRef = this.dialog.open(ModalConfirmRequestComponent);
    dialogRef.componentInstance.submitRequestEmitter.subscribe(() => {
      this.loading = true;
      this.esService.createES(newRequestData).subscribe({
        next: () => {
          this.loading = false;
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('newRequestOk'),
              redirect: true,
              list: true,
              theme: 'ligth'
            },
            disableClose: true
          });
        },
        error: () => {
          this.loading = false;
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('newRequestKO'),
              close: true,
              theme: 'ligth'
            },
            disableClose: true
          });
        }
      });
    });
  }

  sendRequest(newRequestData: any) {
    this.openConfirmationModal(newRequestData);
  }
}
